import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    username: "",
    authenticatorSource: "unknown"
  },
  reducers: {
    setUser: (state, action) => {
      state.username = action.payload;
    },
    setAuthenticatorSource: (state, action) => {
      state.authenticatorSource = action.payload;
    }
  }
});

export const { setUser, setAuthenticatorSource } = userSlice.actions;
export default userSlice.reducer;
